import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import AngleRightIcon from "@/assets/icons/tipo-angle-right.svg?react";
import TrashIcon from "@/assets/icons/tipo-trash.svg?react";
import { ESCOPO_MACRO } from "../../../../../nova-obra.constants";
import type { EscopoMacroLinhaProps } from "./types-escopo-macro-linha";
import styles from "./escopo-macro-linha.module.scss";

/** Escopo macro recolhido em uma linha (Figma `escopo-macro/linha`); View passiva, controles desabilitados. */
export function EscopoMacroLinhaView({
  nome,
  resumo,
  incompleto = false,
  testId,
}: EscopoMacroLinhaProps) {
  return (
    <div className={styles.linha} data-testid={testId}>
      <Button
        type="button"
        rounded
        text
        size="small"
        severity="secondary"
        icon={<AngleRightIcon aria-hidden />}
        aria-label={`${ESCOPO_MACRO.expandir} ${nome}`}
        disabled
      />
      <span className={styles.texto}>
        <span className={styles.nome}>{nome}</span>
        <span className={styles.resumo}>{resumo}</span>
      </span>
      {incompleto ? <Tag severity="warning" value={ESCOPO_MACRO.incompleto} /> : null}
      <Button
        type="button"
        rounded
        text
        size="small"
        severity="secondary"
        icon={<TrashIcon aria-hidden />}
        aria-label={`${ESCOPO_MACRO.remover} ${nome}`}
        disabled
      />
    </div>
  );
}
